import React from "react";
import { Modal, Button } from "antd";
import { CalendarDays, TrendingUp } from "lucide-react";
import "./revalidate-dialog.scss";

export default function RevalidateDialog({
  visible,
  revalidateResult,
  priceInfo,
  onResearched,
  onContinued,
  onClose,
}) {
  if (!revalidateResult) return null;

  const { status, title, message } = revalidateResult;

  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      maskClosable={false}
      centered
      width={320}
      onCancel={onClose}
      className="revalidate-modal"
    >
      <div className="dialog-content">
        {/* Icon */}
        {status === "Price rise" && (
          <TrendingUp className="dialog-icon price-rise" />
        )}

        {status === "Sold out" && (
          <CalendarDays className="dialog-icon sold-out" />
        )}

        {/* Title */}
        {title && <div className="dialog-title">{title}</div>}

        {/* Price Section */}
        {status === "Price rise" && priceInfo && (
          <>
            <div className="dialog-old-price">
              {priceInfo.strikethroughTotalPrice?.title}{" "}
              {priceInfo.strikethroughTotalPrice?.content}
            </div>

            <div className="dialog-new-price">
              {priceInfo.totalPrice?.title} {priceInfo.totalPrice?.content}
            </div>
          </>
        )}

        {/* Message */}
        <div className="dialog-message">{message}</div>

        {/* Actions */}
        {status === "Sold out" && (
          <Button
            type="primary"
            block
            className="primary-btn"
            onClick={() => {
              onClose?.();
              onResearched?.();
            }}
          >
            Search Again
          </Button>
        )}

        {status === "Price rise" && (
          <>
            <Button
              type="primary"
              block
              className="primary-btn"
              onClick={() => {
                onClose?.();
                onContinued?.();
              }}
            >
              Continue Booking
            </Button>

            <Button
              block
              className="outlined-btn"
              onClick={() => {
                onClose?.();
                onResearched?.();
              }}
            >
              Search Again
            </Button>
          </>
        )}
      </div>
    </Modal>
  );
}
